(function () {
  if (customElements.get('predictive-search')) return;

  customElements.define('predictive-search', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.form = this.querySelector('form');
      this.timer = null;
      this.controller = null;
      if (!this.input || !this.results || this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.input.addEventListener('input', () => this.queue());
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    queue() {
      window.clearTimeout(this.timer);
      const term = this.input.value.trim();
      if (term.length < 2) { this.close(); return; }
      this.timer = window.setTimeout(() => this.search(term), 220);
    }

    search(term) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku,tag'
      });
      fetch(this.dataset.url + '?' + params.toString(), { signal: this.controller.signal })
        .then((response) => { if (!response.ok) throw new Error(response.status); return response.text(); })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const section = doc.querySelector('#shopify-section-predictive-search');
          this.results.innerHTML = section ? section.innerHTML : '';
          this.results.hidden = !this.results.innerHTML.trim();
          this.input.setAttribute('aria-expanded', this.results.hidden ? 'false' : 'true');
        })
        .catch((error) => { if (error.name !== 'AbortError') this.close(); });
    }

    onKeydown(event) {
      if (event.key === 'Escape') { this.close(); return; }
      if (event.key !== 'ArrowDown' || this.results.hidden) return;
      const first = this.results.querySelector('a');
      if (first) { event.preventDefault(); first.focus(); }
    }

    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
  });
})();
